export default "__VITE_ASSET__BBpSL6ZH__"